export default __webpack_public_path__ + "static/media/Prissy.e8f2c695.png";